import type { IdeaStatus } from "../lib/types";

const CONFIG: Record<IdeaStatus, { label: string; className: string }> = {
  raw: { label: "raw", className: "bg-amber-100 text-amber-700" },
  refining: { label: "refining", className: "bg-blue-100 text-blue-700" },
  ready: { label: "ready", className: "bg-green-100 text-green-700" },
  filed: { label: "filed", className: "bg-purple-100 text-purple-700" },
};

export function StatusBadge({ status }: { status: IdeaStatus }) {
  const { label, className } = CONFIG[status] ?? CONFIG.raw;
  return (
    <span className={`text-xs font-mono px-1.5 py-0.5 rounded ${className}`}>{label}</span>
  );
}
